import { formatInTimeZone } from 'date-fns-tz'

export function ctz(date: string, timeZone: string) {
  return formatInTimeZone(date, timeZone, 'yyyy-MM-ddHH:mm:sszzz') // 2014-10-25 06:46:20 EST
}

const locale = 'en-IN';
const options = {
  style: "currency",
  currency: "INR"
}

export const formatter = new Intl.NumberFormat(locale, options);

export const currencyFormatter = (value: number) => {
  return formatter.format(value);
}


export const getAttendacePercentage = (present: number, total: number) => {
  if (!present || !total) {return 0;}
  if (present === 0 || total === 0) {return 0;}
  return Number(((present / total) * 100).toFixed(0));
};

export const capitalizeFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);